import { ILogger } from '@cian/logger';

import { objIsOffer } from './presenter';
import { ChatMessageValidationError, ChatOfferValidationError, ChatUsersValidationError } from '../errors';
import { TChatDataInListSchema } from '../types/chatList';

interface IValidateChatItemParameters {
  chat: TChatDataInListSchema;
  logger?: ILogger;
}

export function validateChatItem({ chat, logger }: IValidateChatItemParameters): boolean {
  // Временная функция, пока нет возможности сделать logger обязательным
  const logError = (error: Error) => {
    if (logger) {
      logger.error(error);
    } else {
      console.error(error);
    }
  };

  try {
    if (!chat.data || (chat.type === 'offer' && (!chat.data.offer || !objIsOffer(chat.data.offer)))) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствует корректный data.offer, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    if (!chat.message) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле message, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    if (!('userId' in chat.message)) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле message.userId, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            //FIXME: разобраться с type never
            messageId: chat.message['messageId'],
          },
        }),
      );

      return false;
    }

    if (!('text' in chat.message)) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле message.text, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            //FIXME: разобраться с type never
            messageId: chat.message['messageId'],
          },
        }),
      );

      return false;
    }

    if (!chat.users) {
      logError(
        new ChatUsersValidationError({
          message: `В чате отсутствует поле users, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    // TODO Это условие ломает много сценарие, но непонятно что дает. Нужно помониторить ошибки, если будут.
    // if (chat.users.length < 2) {
    //   logError(
    //     new ChatUsersValidationError({
    //       message: `В чате chatId: ${chat.chatId} в поле users менее двух собеседников`,
    //       domain: 'utils.validate.validateChatItem',
    //       details: {
    //         chatId: chat.chatId,
    //       },
    //     }),
    //   );

    //   return false;
    // }

    if (chat.users.length === 2 && chat.users[0].userId === chat.users[1].userId) {
      logError(
        new ChatUsersValidationError({
          message: `В чате chatId: ${chat.chatId} в поле users совпадают userId собеседников`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            chatUsers: chat.users.map(user => user.userId),
          },
        }),
      );

      return false;
    }

    return true;
  } catch (error) {
    logError(error);

    return false;
  }
}
